// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1S4AE","disabled":"FileBtn_disabled__21cMb","warn":"FileBtn_warn__HjJQG","fade":"FileBtn_fade__1k_52"};